module.exports = __webpack_public_path__ + "static/media/games-dev.86ead3ca.jpg";